export type ExpenseNature = 'routine' | 'stock' | 'payroll' | 'admin-finance' | 'capital';

export interface ExpenseCategory {
  id: string;
  name: string;                     // e.g., "Engine Service"
  typeId: string;                   // Mill / Vehicle (renamed from 'type')
  costCenterId: string;            // Parent cost center (replaces 'costCenter')
  nature: ExpenseNature;           // Required field now
  needsNameField?: boolean;        // Renamed from 'requiresNameField'
  isActive: boolean;               // Renamed from 'active'
  createdBy: string;               // Required audit field
  createdAt: any;                  // Required audit field (Timestamp)
  updatedAt: any;                  // Required audit field (Timestamp)

  // Legacy fields for backward compatibility (will be removed after migration)
  type?: string;                   // DEPRECATED: use typeId
  costCenter?: string;             // DEPRECATED: use costCenterId
  active?: boolean;                // DEPRECATED: use isActive
  requiresNameField?: boolean;     // DEPRECATED: use needsNameField
  supportsUnits?: boolean;         // DEPRECATED: not used
  unitLabel?: string;              // DEPRECATED: not used
  updatedBy?: string;              // DEPRECATED: use updatedAt with user context
}

// Helper type for creating new categories (excludes computed fields)
export interface CreateCategoryRequest {
  name: string;
  typeId: string;
  costCenterId: string;
  nature: ExpenseNature;
  needsNameField?: boolean;
  isActive?: boolean;
}

// Helper type for updating categories
export interface UpdateCategoryRequest extends Partial<CreateCategoryRequest> {
  id: string;
}

export const EXPENSE_NATURES: { value: ExpenseNature; label: string; description: string }[] = [
  {
    value: "routine",
    label: "Routine",
    description: "Regular operational expenses like utilities, rent, maintenance"
  },
  {
    value: "stock",
    label: "Stock",
    description: "Inventory purchases, raw materials, goods for resale"
  },
  {
    value: "payroll",
    label: "Payroll",
    description: "Employee salaries, wages, benefits, and related costs"
  },
  {
    value: "admin-finance",
    label: "Admin & Finance",
    description: "Administrative costs, banking fees, professional services"
  },
  {
    value: "capital",
    label: "Capital",
    description: "Fixed asset purchases, equipment, infrastructure investments"
  }
];

// Utility function to generate composite label: Category Name (Cost Center)
export function getCategoryDisplayLabel(category: ExpenseCategory, costCenterName?: string): string {
  if (costCenterName) {
    return `${category.name} (${costCenterName})`;
  }
  return category.name;
}
